module.exports = "<app-header></app-header>\n<div class=\"row contenedor\">\n\n  <div class=\"col-lg-10 col-md-9 col-sm-12\">\n    <app-map></app-map>\n  </div>\n\n  <div class=\"col-lg-2 col-md-3 col-sm-12\" id=\"aside\">\n    <app-aside></app-aside>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main